var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTezos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 48 48",
    viewBox: "0 0 48 48",
    id: "tezos",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f4b545",
    d: "M24,1.25C11.44,1.25,1.25,11.44,1.25,24c0,12.56,10.19,22.75,22.75,22.75S46.75,36.56,46.75,24 C46.75,11.44,36.56,1.25,24,1.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f9c662",
    d: "M24,6C14.06,6,6,14.06,6,24c0,9.94,8.06,18,18,18s18-8.06,18-18C42,14.06,33.94,6,24,6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#393d42",
    d: "M24,47.5C11.04,47.5,0.5,36.96,0.5,24S11.04,0.5,24,0.5c12.96,0,23.5,10.54,23.5,23.5S36.96,47.5,24,47.5z  M24,2C11.87,2,2,11.87,2,24s9.87,22,22,22c12.13,0,22-9.87,22-22S36.13,2,24,2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#393d42",
    d: "M24,42.75C13.66,42.75,5.25,34.34,5.25,24S13.66,5.25,24,5.25S42.75,13.66,42.75,24S34.34,42.75,24,42.75z  M24,6.75C14.49,6.75,6.75,14.49,6.75,24S14.49,41.25,24,41.25S41.25,33.51,41.25,24S33.51,6.75,24,6.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#393d42",
    d: "M22.64,28.51c-1.48,0-2.68-1.2-2.68-2.68V14.91l-0.88,0.25l-0.42-1.44l1.83-0.53 c0.23-0.06,0.47-0.02,0.66,0.12c0.19,0.14,0.3,0.36,0.3,0.6v11.92c0,0.65,0.53,1.18,1.18,1.18s1.18-0.53,1.18-1.18v-0.16h1.5v0.16 C25.32,27.31,24.12,28.51,22.64,28.51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#393d42",
    d: "M26.2,34.84c-0.84,0-2.83-0.13-4.08-1.24c-0.68-0.6-1.05-1.39-1.1-2.33l1.5-0.08 c0.03,0.54,0.22,0.96,0.59,1.28c0.93,0.82,2.75,0.9,3.39,0.85c0.39-0.02,3.69-0.32,3.69-3.9c0-4.37-5.23-5.08-5.46-5.11 c-0.28-0.04-0.52-0.23-0.62-0.5c-0.09-0.27-0.02-0.57,0.18-0.77l4.8-4.8H17.06v-1.5h13.85c0.3,0,0.58,0.18,0.69,0.46 c0.12,0.28,0.05,0.6-0.16,0.82l-5.11,5.11c2.37,0.7,5.36,2.55,5.36,6.3c0,4.06-3.34,5.31-5.1,5.4 C26.57,34.83,26.42,34.84,26.2,34.84z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTezos);
export default __webpack_public_path__ + "static/media/tezos.682ba81296df09016af177c1cf64fdd8.svg";
export { ForwardRef as ReactComponent };